import React, { Fragment } from "react";
import logoImg from 'cd-eft/assets/images/usda-logo-name.png';
import { getMonthDayYear } from 'cd-eft/utils/formatDate';
import './ReportHeader.scss';

export const ReportHeader = () => {
    return (
        <Fragment>
            <div className="row report-header">
                <div className='col header-left'>
                    <img src={logoImg} alt='USDA Logo' tabIndex={1} />
                </div>
                <div className='col header-right' tabIndex={2}>
                    <span className='row bold'>Report Generated</span>
                    <span className='row'>{getMonthDayYear()}</span>
                </div>
            </div>
        </Fragment>
    )
}